import React, { memo, useContext, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system';
import { useMainStackNavigation, useMainStackRoute } from 'utils/types/navigationV6';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { InvestWalkthroughContext } from 'features/feed/components/walkthrough/context';
import StockAssetRow from './StockAssetRow';
import useStockMeta from '../hooks/useStockMeta';
const ReadyMadeFund = ({ assetId }) => {
    const navigation = useMainStackNavigation();
    const isInInvestWalkthrough = useContext(InvestWalkthroughContext);
    const route = useMainStackRoute();
    const stockMeta = useStockMeta(assetId);
    const rowProps = useMemo(() => ({
        iconUrl: stockMeta?.iconUrl,
        name: stockMeta?.name,
        description: stockMeta?.description,
        shortDescription: stockMeta?.shortDescription,
        averageAnnualReturn: stockMeta?.averageAnnualReturn,
    }), [stockMeta]);
    const handlePress = React.useCallback(() => {
        if (route.params?.depositAndBuyFlowParams) {
            navigation.navigate('InvestStock', {
                assetId,
                depositAndBuyFlowParams: route.params.depositAndBuyFlowParams,
            });
            return;
        }
        navigation.navigate('InvestStock', {
            assetId,
        });
    }, [assetId, route.params]);
    return (<TouchableBounceCard onDark noMarginBottom noMargin={isInInvestWalkthrough} style={isInInvestWalkthrough ? styles.walkthroughCard : undefined} onPress={handlePress}>
      <StockAssetRow {...rowProps}/>
    </TouchableBounceCard>);
};
export default memo(ReadyMadeFund);
const styles = StyleSheet.create({
    walkthroughCard: {
        marginTop: rem(4),
        marginBottom: rem(4),
        marginHorizontal: rem(4),
    },
});
